__turbopack_context__.v({
  "className": "noto_sans_b9059c03-module__a8v0Jq__className",
  "variable": "noto_sans_b9059c03-module__a8v0Jq__variable",
});
